// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spinAround{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}entry-box{display:block}entry-box:not(:last-child){margin-bottom:2.5rem}@media screen and (min-width: 1044px){entry-box:not(:last-child){margin-bottom:48px}}\n", ""]);
// Exports
module.exports = exports;
